import * as React from 'react';
import { withLocalize, LocalizeContextProps } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Row, Col, Layout, Button } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";
import InfoBox from "src/components/mission/InfoBox";
import UserApiController from 'src/api/UserApiController';
import UpdateUserGameDTO from 'src/models/user/UpdateUserGameDTO';
import DebugUtil from "src/utils/DebugUtil";
import { Checkpoints } from "src/constants/Checkpoints";
import { Track } from 'src/providers/TelemetryService';

const { Content } = Layout;

interface StudentGameProps extends EnhancedProps {
}

class StudentGame extends React.Component<StudentGameProps> {
    constructor(props: StudentGameProps) {
        super(props);
        bindAllOfThis(this, StudentGame.prototype);
    }

    componentDidMount() {
        const { id: gameId, name: gameName } = this.props.currentGame;
        const { id: planetId, name: planetName } = this.props.currentPlanet;
        Track.PlayGame(gameName, gameId, planetName, planetId);
    }

    skipGame() {
        const { id: gameId, name: gameName } = this.props.currentGame;
        const { id: planetId, name: planetName } = this.props.currentPlanet;
        Track.SkipGame(gameName, gameId, planetName, planetId);
        this.props.skipToCheckpoint(Checkpoints.Activity);
    }

    completeGame() {
        this.informBackend();
        const { id: gameId, name: gameName } = this.props.currentGame;
        const { id: planetId, name: planetName } = this.props.currentPlanet;
        Track.CompleteGame(gameName, gameId, planetName, planetId);
        this.props.onNext();
    }

    informBackend() {
        let updatedUserGameDTO: UpdateUserGameDTO = {
            gameId: this.props.currentGame.id
        };

        UserApiController.markGameCompleted(updatedUserGameDTO).then(result => {
            if (DebugUtil.isDebugEnabled()) {
                console.warn("Marked Game as Completed in DB");
            }
        });
    }

    renderGame() {
        if (this.props.currentGame.component != null) {
            return <this.props.currentGame.component onComplete={() => this.completeGame()} />;
        }
        return null;
    }

    render() {
        this.props.onChangeAudio("");

        return <Content className="mission-game" style={{ height: '100vh', overflow: 'hidden' }}>
            <Button tabIndex={0} type="primary" className="skip-game" onClick={() => this.skipGame()}>Skip Game</Button>
            {this.renderGame()}
        </Content>;
    }
}

export default StudentGame;



// WEBPACK FOOTER //
// ./src/pages/student/scenes/StudentGame.tsx